var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-buttons"},[_c('promocion-btn'),_c('cart-btn'),_c('messages-btn'),_c('auth-btn')],1)}
var staticRenderFns = []

export { render, staticRenderFns }